/** An action as far as the confirm rules read it. */
interface ConfirmableAction {
  readonly can_confirm?: boolean;
}

/**
 * Whether the caller may answer an action or save its inputs: the backend's per-action `can_confirm` (nap-backend#1951),
 * the same check its respond routes make for that action. A backend before that sends only the message's flag, which is
 * true only when every open action may be answered, so it stands in.
 */
export const mayAnswerAction = (action: ConfirmableAction, messageCanConfirm: boolean): boolean => action.can_confirm ?? messageCanConfirm;

/**
 * Whether an action's confirm zone is not its message's zone, as for an action added from another zone's queue. Compared
 * by id; an unknown zone on either side, as from a backend that sends none, is not flagged.
 */
export const confirmZoneDiffers = (zoneId: number | null | undefined, messageZoneId: number | null | undefined): boolean =>
  typeof zoneId === 'number' && typeof messageZoneId === 'number' && zoneId !== messageZoneId;
